import { OperationExecutor as UntypedOperationExecutor, useExecutor as untypedUseExecutor } from "@amazeelabs/executors";
export * from "./generated/index.js";
export * from "@amazeelabs/scalars";
export * from "./locale.js";
export function OperationExecutor(props) {
    return UntypedOperationExecutor(props);
}
export function useExecutor(id, variables) {
    return untypedUseExecutor(id, variables);
}
